module.exports = __webpack_public_path__ + "img/pin.4aaef4e0.svg";